import { publishSimilaritySearch } from '../helpers/publishSearchAssets';
import { SimilarityFilter } from '../helpers/types';

export const emitSimilaritySearchEvent = (
	isHybridSearchOn: boolean,
	similarityFilter: SimilarityFilter,
) => {
	publishSimilaritySearch(isHybridSearchOn, similarityFilter);
};
